<template>
    <form action="POST" @submit.prevent="handleRegisterForm()">
        <!-- <div class="row form-heading">
            <div class="col-lg-12">
                <h2>Zaloguj się</h2>
                <p>
                    Nie posiadasz konta?
                    <a href="/#rejestracja">Zarejestruj się</a>
                </p>
            </div>
        </div> -->
        <div class="row">
            <div class="col-lg-6">
                <form-input
                    label="Adres E-mail"
                    v-model="email"
                    :modelValue="email"
                    type="email"
                    name="email"
                    placeholder="E-mail"
                    :error-messages="errorMessage"
                ></form-input>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <form-input
                    label="Hasło"
                    v-model="password"
                    :modelValue="password"
                    type="password"
                    name="password"
                    placeholder="hasło"
                    :error-messages="errorMessage"
                ></form-input>
            </div>
        </div>
        <div class="gradient gradient--login">
            <div class="row">
                <div class="col-lg-6 login-bottom">
                    <div class="left">
                        <div class="form-check">
                            <input
                                v-model="remember"
                                class="form-check-input"
                                type="checkbox"
                                name="remember"
                                id="remember"
                                value="true"
                                checked
                            />
                            <label class="form-check-label" for="remember">
                                Zapamiętaj hasło
                            </label>
                        </div>
                    </div>
                    <div class="login-div">
                        <vue-simple-spinner
                            v-if="processing"
                        ></vue-simple-spinner>
                        <button class="login-button" v-else>Zaloguj</button>
                    </div>
                    <div>
                        <a href="/password/reset" class="reminder"
                            >Nie pamiętasz hasła?</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import FormInput from "./formInput";
import Spinner from "vue-simple-spinner";

export default {
    components: {
        FormInput,
        Spinner,
    },
    data() {
        return {
            email: "",
            password: "",
            remember: "",
            processing: "",
            errorMessage: null,
        };
    },

    methods: {
        handleRegisterForm() {
            axios
                .post("/api/login", {
                    email: this.email,
                    password: this.password,
                    remember: this.remember,
                })
                .then((response) => {
                    this.processing = true;
                })
                .then((response) => {
                    this.processing = false;
                    window.location.href = "/";
                })
                .catch((error) => {
                    this.errorMessage = error.response.data.errors;
                })
                .then((error) => {
                    window.scrollTo(
                        document.querySelector(".error").offsetTop,
                        0
                    );
                });
        },
    },
};
</script>
